import type { ContentLanguage } from "@repo/shared/api";

import { mixpanelTrack } from "./mixpanelTrack";

const SECTION = "Nav Bar";

export const trackNavBarUpgrade = () =>
  mixpanelTrack("upgrade", {
    section: SECTION,
    context: "cta",
    action_type: "lifecycle",
  });

/** Any click on a language in the picker, including re-picking the current one. */
export const trackChangeLanguage = (props: {
  language: ContentLanguage;
  previous_language: ContentLanguage;
}) =>
  mixpanelTrack("change_language", {
    section: SECTION,
    action_type: "user_investment",
    ...props,
  });

/** Opened from the nav button or the Shift+7 shortcut. */
export const trackSearchOpened = (props: { method: "button" | "shortcut" }) =>
  mixpanelTrack("open_search", {
    section: SECTION,
    action_type: "browse",
    ...props,
  });

/**
 * A player picked out of the search results. The typed term is deliberately
 * left out: nothing else in the app reports raw user input, and its length
 * next to the result count answers the same questions about whether the
 * search is finding things.
 */
export const trackSearchResultClicked = (props: {
  term_length: number;
  result_count: number;
  /** 1-based rank of the picked card, to see whether the ordering is right. */
  position: number;
}) =>
  mixpanelTrack("select_search_result", {
    section: SECTION,
    action_type: "browse",
    ...props,
  });
